import React from 'react';
import { styles } from './AlternativesProduct.css';
import { AlgoliaHitTransformer } from '../../Algolia/transformers/AlgoliaHitTransformer';
import { ProgressiveImage } from '../../hooks/useProgressiveImage/useProgressiveImage';
import { ProductImageFallback } from '../../ProductImageFallback/ProductImageFallback';
import Button from '@jbhi-fi/lanyard-ui/components/Button';
import PriceFont from '@jbhi-fi/lanyard-ui/font/PriceFont';

export type AlternativesProductProps = {
  title: string;
  productImage: string;
  price: number;
  onAddToCart: (e: React.SyntheticEvent) => void;
};

export const AlternativesProduct = ({ title, price, productImage, onAddToCart }: AlternativesProductProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.background} />
      <div className={styles.leftContent}>
        Viewing product:
        <div className={styles.imageContainer}>
          <div className={styles.image}>
            {productImage ? (
              <ProgressiveImage
                className={styles.image}
                {...AlgoliaHitTransformer.toProgressiveImageProps(
                  { product_image: productImage, title },
                  { sizePx: 300 }
                )}
              />
            ) : (
              <ProductImageFallback className={styles.image} />
            )}
          </div>
          <div className={styles.title} data-testid="product-card-title">
            {title}
          </div>
        </div>
      </div>
      <div className={styles.rightContent}>
        <div className={styles.price} data-testid="product-card-price">
          <PriceFont>${price}</PriceFont>
        </div>
        <div className={styles.actions}>
          <Button type="action" size="sm" fullWidth onClick={onAddToCart} data-testid="product-card-add-to-cart">
            Add to cart
          </Button>
        </div>
      </div>
    </div>
  );
};
